import AvailabilityProvider from "../services/AvailabilityProvider"
import Offer from '../models/Offer'
import DateService from "../services/DateService"

export interface Range {
    min: number,
    max: number,
    min_with_overrides: number,
    max_with_overrides: number
}

export class RangeProvider extends AvailabilityProvider {

    apiEndpoint = 'guests-range'

    private buildBookingParams (): { [index in string] : any } {
        const obj: { [index in string]: string } = {};

        if (this.booking.type) {
            obj.type = this.booking.type.id
        }

        return obj;
    }

    requestRange (): Promise<Range> {
        const url = this._buildUrl(this.booking.venue!)
        let params = this.buildBookingParams()

        const requestUrl = url + this.objToParams(params)

        return this.get(requestUrl)
            .then((response) => {
                const payload = response.data.payload
                
                return payload as Range
            })
    }
}


// WEBPACK FOOTER //
// ./src/services/RangeProvider.ts